import React, { useState } from 'react';
import { Card, Button, notification, Input, Form, Space } from 'antd';
import api from '@/services/api';
import PageShell from '../../Components/PageShell';
import AdminNav from './AdminNav';

const AdminPage = () => {
    const [isDownloading, setIsDownloading] = useState(false);
    const [form] = Form.useForm();

    const handleImportTraders = async () => {
        try {
            const response = await api.post('/admin/import-traders');
            notification.open({
                type: 'success',
                message: 'Import Started',
                description: 'Started importing traders from UK Trade Info'
            });
        } catch (error) {
            notification.open({
                type: 'error',
                message: 'Import Failed',
                description: 'Failed to import traders: ' + error.message
            });
        }
    };

    const handleDownloadTrades = async () => {
        try {
            setIsDownloading(true);
            const values = await form.validateFields();
            const monthId = values.monthId;

            // Validate YYYYMM format
            if (!/^\d{6}$/.test(monthId)) {
                throw new Error('Month ID must be in YYYYMM format (e.g., 202401)');
            }

            const response = await api.post('/admin/download-trades', { monthId }, { responseType: 'blob' });
            
            // Create a download link
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `trades_${monthId}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            notification.open({
                type: 'success',
                message: 'Download Complete',
                description: `Trade data for ${monthId} has been downloaded`
            });
        } catch (error) {
            notification.open({
                type: 'error',
                message: 'Download Failed',
                description: error.message || 'Failed to download trade data'
            });
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <PageShell wrap={false}>
        <AdminNav />
        <div style={{ padding: '24px' }}>
            <h1>Admin Functions</h1>
            
            <Card title="Data Import Functions" style={{ marginTop: '24px' }}>
                <Button 
                    type="primary" 
                    onClick={handleImportTraders}
                >
                    Import Traders from UK Trade Info
                </Button>
            </Card>

            <Card title="Trade Data Download" style={{ marginTop: '24px' }}>
                <Form form={form} layout="inline">
                    <Form.Item
                        name="monthId"
                        label="Month ID (YYYYMM)"
                        rules={[
                            { required: true, message: 'Please enter month ID' },
                            { pattern: /^\d{6}$/, message: 'Must be in YYYYMM format (e.g., 202401)' }
                        ]}
                    >
                        <Input placeholder="202401" style={{ width: '120px' }} />
                    </Form.Item>
                    <Form.Item>
                        <Button 
                            type="primary" 
                            onClick={handleDownloadTrades}
                            loading={isDownloading}
                        >
                            Download Trade Data
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
        </PageShell>
    );
};

export default AdminPage;